/** Tallest the clinical-tag suggestion list grows (Tailwind max-h-56). */
export const SUGGESTION_LIST_MAX_HEIGHT = 224;
/** Never squeeze the list below ~3 rows, even when both sides are tight. */
const SUGGESTION_LIST_MIN_HEIGHT = 96;
const GAP = 4;
/**
 * Where the autocomplete list goes: below its anchor when it fits there (or
 * when below is still the roomier side), otherwise above. The clinical-tags
 * field is usually the last thing in the report form, so below is often cut
 * off by the editor's scroll area and the action bar, or covered by the
 * on-screen keyboard.
 */
export function pickSuggestionPlacement({ spaceAbove, spaceBelow, listHeight, }) {
    const fitsBelow = spaceBelow >= Math.min(listHeight, SUGGESTION_LIST_MAX_HEIGHT) + GAP;
    const side = fitsBelow || spaceBelow >= spaceAbove ? 'below' : 'above';
    const room = (side === 'below' ? spaceBelow : spaceAbove) - GAP;
    return {
        side,
        maxHeight: Math.max(SUGGESTION_LIST_MIN_HEIGHT, Math.min(SUGGESTION_LIST_MAX_HEIGHT, room)),
    };
}
/**
 * The part of the screen `el` can actually show: its nearest clipping
 * (scrolling) ancestor intersected with the visual viewport, which on iOS
 * excludes the on-screen keyboard. In layout-viewport coordinates, the same
 * space getBoundingClientRect() reports in.
 */
export function visibleBounds(el) {
    const vv = window.visualViewport;
    let top = vv ? vv.offsetTop : 0;
    let bottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
    for (let node = el.parentElement; node; node = node.parentElement) {
        const overflowY = getComputedStyle(node).overflowY;
        if (!overflowY || overflowY === 'visible')
            continue;
        const rect = node.getBoundingClientRect();
        top = Math.max(top, rect.top);
        bottom = Math.min(bottom, rect.bottom);
        break;
    }
    return { top, bottom };
}
